export const testPixel = (ch: number): Promise<boolean> =>
  new Promise((resolve, reject) => {
    const px = new Image();
    px.src = `/assets/img/px.gif?ch=${ch}`;
    px.onload = () => resolve(true);
    px.onerror = () => resolve(false);
    setTimeout(() => reject('pixel timed out'), 2000);
  });
